import type { Exit, RegistrationContext } from './types';

export type ExitTarget =
  { kind: 'internal'; path: string } | { kind: 'external'; url: string };

const defaultEnv = () => ({
  checkoutUrl:
    process.env.REACT_APP_CHECKOUT_URL || 'https://checkout.dev.ayeface.com',
  onglayeUrl:
    process.env.REACT_APP_ONGLAYE_URL || 'https://onglaye.dev.ayeface.com'
});

export function exitUrl(
  exit: Exit,
  ctx: RegistrationContext,
  env: { checkoutUrl: string; onglayeUrl: string } = defaultEnv()
): ExitTarget {
  switch (exit) {
    case 'home':
      return { kind: 'internal', path: '/' };
    case 'homeAddPayment':
      return { kind: 'internal', path: '/?add_payment=1' };
    case 'checkout':
      return {
        kind: 'external',
        url: `${env.checkoutUrl}/payment${
          ctx.account?.methodLinked ? '?link_status=success' : ''
        }`
      };
    case 'onglaye':
      return {
        kind: 'external',
        url: `${env.onglayeUrl}/payment?ong_key=${encodeURIComponent(
          ctx.ongKey ?? ''
        )}`
      };
  }
}

/**
 * Where a gateway return opened without a stored registration sends the visitor back to: the
 * checkout or OngLaye payment page named by the return URL's `checkout_session_id` or
 * `ong_key`. The checkout URL carries the session id itself, so it also works in a browser
 * that never had the checkout open. Null when the URL names neither.
 */
export function standaloneReturnUrl(
  search: string,
  outcome: 'success' | 'failed',
  env: { checkoutUrl: string; onglayeUrl: string } = defaultEnv()
): string | null {
  const q = new URLSearchParams(search);
  const sessionId = q.get('checkout_session_id');
  const ongKey = q.get('ong_key');
  const params = new URLSearchParams();
  let base: string;
  if (sessionId) {
    base = `${env.checkoutUrl}/payment`;
    params.set('session_id', sessionId);
  } else if (ongKey) {
    base = `${env.onglayeUrl}/payment`;
    params.set('ong_key', ongKey);
  } else {
    return null;
  }
  if (outcome === 'success') params.set('link_status', 'success');
  return `${base}?${params.toString()}`;
}
